import { useState } from "react";
import { Alert, Anchor, Button, TextInput, Space, Text, Title } from "@mantine/core";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { IconMail, IconArrowLeft } from "@tabler/icons-react";

import { REQUEST_PASSWORD_RESET_MUTATION } from "../../../queries/auth";

export default function ForgotPasswordForm({ setMode }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [requestPasswordReset] = useMutation(REQUEST_PASSWORD_RESET_MUTATION, {
    onCompleted: (data) => {
      setLoading(false);
      if (data.requestPasswordReset.status === 200) {
        setMessage({
          type: "success",
          text: data.requestPasswordReset.response
        });
      } else {
        setMessage({
          type: "error",
          text: data.requestPasswordReset.error
        });
      }
    },
    onError: (err) => {
      setLoading(false);
      setMessage({
        type: "error",
        text: "Network error. Please check your connection and try again."
      });
      console.error('Password reset error:', err);
    },
  });

  const handleResetPassword = () => {
    // Validation
    if (!email) {
      setMessage({
        type: "error",
        text: "Please enter your email address."
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({
        type: "error",
        text: "Please enter a valid email address."
      });
      return;
    }

    setLoading(true);
    setMessage(null);
    requestPasswordReset({ variables: { email } });
  };

  return (
    <div className="forgot-password">
      <div className="form-container">
        <Title order={2} align="center" mb="md">
          Reset Your Password
        </Title>
        <Text align="center" color="dimmed" size="sm" mb="xl">
          Enter your email address and we'll send you a link to reset your password.
        </Text>

        <TextInput
          icon={<IconMail size={16} />}
          placeholder="example@gmail.com"
          label="Email Address"
          size="md"
          value={email}
          onChange={(event) => setEmail(event.currentTarget.value)}
          disabled={loading}
          onKeyPress={(e) => e.key === 'Enter' && handleResetPassword()}
          required
        />
        
        <Space h="xl" />
        
        <Button
          fullWidth
          variant="filled"
          size="md"
          onClick={handleResetPassword}
          loading={loading}
        >
          Send Reset Link
        </Button>
        
        <Space h="lg" />
        
        {message && (
          <>
            <Alert
              color={message.type === "error" ? "red" : "green"}
              title={message.type === "error" ? "Error" : "Success"}
              radius="md"
            >
              {message.text}
              {message.type === "success" && (
                <>
                  <br /><br />
                  <strong>📧 Check your inbox</strong> (and spam/junk folder)
                </>
              )}
            </Alert>
            <Space h="lg" />
          </>
        )}
        
        <Text align="center">
          <Anchor 
            onClick={() => {
              setMode('login');
              navigate('/login');
            }}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <IconArrowLeft size={16} style={{ marginRight: 5 }} />
            Back to Login
          </Anchor>
        </Text>
      </div>
    </div>
  );
}
